import { BearingIcon, BoxIcon, Repair3Icon, RepairIcon, SafeIcon } from "@/shared/icons";

export const improvementsIconsList = {
  safe: SafeIcon,
  warehouse: BoxIcon,
  cleaningtools: RepairIcon,
  repairtools: Repair3Icon,
  businessrelations: BearingIcon,
};
